export const filterVoiceQuickConnects = (quickConnects: connect.Endpoint[]): connect.Endpoint[] =>
  quickConnects.filter(quickConnect => !quickConnect.name.toLowerCase().includes('email'));
